export enum UnlockStep {
  main,
  lock,
  securityPin,
  emailSent,
}
